import { rootApi } from "..";
import { menusService } from "../../../Api/Services/MenusService";
import {
  IAssignMenuToUserPayload,
  IMenuFormData,
} from "../../../features/menus/types";
import { makeEndpoints } from "../../../utils/rtkQueryFactory";

const menusEndpoints = [
  {
    name: "getMenusList",
    type: "query",
    serviceFn: () => menusService.getMenus(),
    tagType: "Menus",
  },
  {
    name: "createMenu",
    type: "mutation",
    serviceFn: (data: IMenuFormData) => menusService.createMenu(data),
    tagType: "Menus",
  },
  {
    name: "updateMenu",
    type: "mutation",
    serviceFn: ({ id, data }: { id: number; data: IMenuFormData }) =>
      menusService.updateMenu(id, data),
    tagType: "Menus",
  },
  {
    name: "deleteMenu",
    type: "mutation",
    serviceFn: (id: number) => menusService.deleteMenu(id),
    tagType: "Menus",
  },
  {
    name: "assignMenuToUser",
    type: "mutation",
    serviceFn: (payload: IAssignMenuToUserPayload) =>
      menusService.assignMenuToUser(payload),
    tagType: "Menus",
  },
  {
    name: "assignMenusUser",
    type: "query",
    serviceFn: (userId: number) => menusService.assignMenusUser(userId),
    tagType: "Menus",
  }
] as const;

export const menusApi = rootApi.injectEndpoints({
  endpoints: (build) => makeEndpoints(build, menusEndpoints),
});

export const {
  useGetMenusListQuery,
  useCreateMenuMutation,
  useUpdateMenuMutation,
  useDeleteMenuMutation,
  useAssignMenuToUserMutation,
  useAssignMenusUserQuery,
  useLazyAssignMenusUserQuery,
} = menusApi;
